import Details from 'govuk-frontend/govuk/components/details/details'

export default Details
